import React from 'react'
import cx from 'classnames'
import styles from './styles.module.scss'

const DownloadButton = ({ className }) => {
  return (
    <div className={cx(className, styles.zoom)}>
      <a
        href="https://apps.apple.com/us/app/recon-food/id1554505144?itsct=apps_box_badge&amp;itscg=30200"
        className={styles.anchor}
      >
        <img
          src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1614556800&h=582ec55a2d39e90d588edc0f50ee00c1"
          alt="Download on the App Store"
          className={styles.image}
        />
      </a>
    </div>
  )
}

export default DownloadButton
